import React from "react";
import SSTLogo from "../assets/images/sstlogo.png";

export default function Header() {
  return (
    <div style={{ margin: 0, padding: 0 }}>
      <nav
        className="navbar navbar-light"
        style={{
          backgroundColor: "#f5fbfe",
          display: "flex",
          justifyContent: "left",
          alignItems: "center",
          height: "60px", // Fixed height to eliminate vertical space
          margin: 0,
          padding: 0,
        }}
      >
        <a className="navbar-brand" href="/" style={{ margin: 0, padding: 0 }}>
          <img
            src={SSTLogo}
            alt="SST Logo"
            style={{ width: "100px", height: "auto", margin: 0, padding: 0 }}
          />
        </a>
      </nav>
    </div>
  );
}
